import { render, staticRenderFns } from "./UserGroupDialog.vue?vue&type=template&id=2532e291&"
import script from "./UserGroupDialog.vue?vue&type=script&lang=js&"
export * from "./UserGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports